import React, { Component } from "react";

class ThankyouContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      language: props.language
    };
    this.gettext = props.gettext;
  }

  render() {
    return (
      <div className="container-fluid">
        <div className="alert alert-success form-intro-alert" role="alert">
          <svg
            className="form-intro-check"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path
              fill="currentColor"
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
            />
          </svg>
          <span>
            {this.gettext("Thank you for registering for the HydroPeptide Digital Education Platform. Your registration is currently undergoing an approval process. You will receive an email within 24 business hours allowing you to create a password and enter the platform.")}
          </span>
        </div>
      </div>
    );
  }
}

export default ThankyouContainer;
